<template>
  <el-tabs v-model="goodsInfoActiveTab" type="card">
    <el-tab-pane :label="$t('BusinessOrderPreemptGoods.skuTitle')" name="sku">
      <SkuList
        v-if="goodsInfoActiveTabHistory.has('sku')"
        :order-id="orderId"
        :has-btn="hasBtn"
        :success="success"
        @onPreemptSkuLineLog="onPreemptSkuLineLog"
        @onAction="onAction"
      />
    </el-tab-pane>
    <el-tab-pane :label="$t('BusinessOrderPreemptGoods.skuItemTitle')" name="skuItem">
      <SkuLineList
        v-if="goodsInfoActiveTabHistory.has('skuItem')"
        :order-id="orderId"
        :has-btn="hasBtn"
        :success="success"
        @onPreemptSkuLineLog="onPreemptSkuLineLog"
        @onAction="onAction"
      />
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import { orderApi } from '@/api';
import SkuList from './SkuList';
import SkuLineList from './SkuLineList';
export default {
  name: 'BusinessOrderPreemptDetailGoodsInfoTab',
  components: { SkuList, SkuLineList },
  props: {
    orderId: {
      type: String,
      default: null,
    },
    hasBtn: {
      type: Boolean,
      default: false,
    },
    success: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      goodsInfoActiveTab: 'sku',
      goodsInfoActiveTabHistory: new Set(['sku']),
    };
  },
  watch: {
    goodsInfoActiveTab(v) {
      this.goodsInfoActiveTabHistory.add(v);
    },
    // orderId变化时，重新渲染LIST
    orderId(v) {
      const temp = this.goodsInfoActiveTabHistory;
      this.goodsInfoActiveTabHistory = new Set();
      this.$nextTick(e => {
        this.goodsInfoActiveTabHistory = temp;
      });
    },
  },
  methods: {
    onPreemptSkuLineLog(row) {
    },
    onAction(action, hasChildren, data) {
      let itemIdList = [];
      let itemIdLineList = [];
      if (!data) {
        this.$message.warning(this.$t('chooseText'));
        return;
      }
      if (!hasChildren) {
        itemIdList = [];
        itemIdLineList = (data || []).map(e => e.id);
      } else {
        itemIdList = (data.parents || []).map(e => e.id);
        itemIdLineList = (data.children || []).map(e => e.id);
      }

      if (!itemIdList.length && !itemIdLineList.length) {
        this.$message.warning(this.$t('chooseText'));
        return;
      }
      // #ifndef OPEN-SOURCE
      switch (action) {
        case this.$t('BusinessOrderPreemptGoods.reReserve'): {
          const POST_DATA = {
            actionType: '0', // 0 重新预占 1解占
            itemIdList: itemIdList,
            itemIdLineList: itemIdLineList,
          };
          this.$confirm(this.$t('BusinessOrderPreemptGoods.reReserveConfirmText1'))
            .then(_ => {
              this.preemptionOrderByItemLine(POST_DATA);
            })
            .catch(_ => {});

          break;
        }
        case this.$t('BusinessOrderPreemptGoods.Uncamp'): {
          const POST_DATA = {
            actionType: '1', // 0 重新预占 1解占
            itemIdList: itemIdList,
            itemIdLineList: itemIdLineList,
          };
          this.$confirm(this.$t('BusinessOrderPreemptGoods.preemptConfirmText'))
            .then(_ => {
              this.preemptionOrderByItemLine(POST_DATA);
            })
            .catch(_ => {});
          break;
        }
        case this.$t('otherText'):
          break;
      }
      // #endif
    },
    preemptionOrderByItemLine(POST_DATA) {
      orderApi.preemptionOrderByItemLine(POST_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$emit('reFresh', this.goodsInfoActiveTab);
          }, 500);
        }
      });
    },
  },
};
</script>
